import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { setPreference, useTheme } from "../lib/theme";

// Compact sun/moon toggle for the top bar (keyboard operable, labelled, visible focus ring via global :focus-visible).
export const ThemeToggle = ({ className = "" }) => {
  const { theme } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  const label = `Switch to ${next} theme`;
  return (
    <button type="button" onClick={() => setPreference(next)} aria-label={label} title={label} data-testid="theme-toggle" data-theme-state={theme}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/5 border border-white/10 text-slate-300 hover:text-cyan-300 hover:border-cyan-400/40 transition-colors ${className}`}>
      {theme === "dark" ? <Sun className="w-4 h-4" aria-hidden="true" /> : <Moon className="w-4 h-4" aria-hidden="true" />}
    </button>
  );
};

const OPTIONS = [["light", "Light", Sun], ["dark", "Dark", Moon], ["system", "System", Monitor]];

// "Appearance: Light / Dark / System" segmented control for the account menu.
export const AppearanceSetting = () => {
  const { preference } = useTheme();
  return (
    <div className="px-3 py-2" data-testid="appearance-setting">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1.5">Appearance</div>
      <div className="inline-flex w-full rounded-full border border-white/10 bg-white/5 p-0.5" role="radiogroup" aria-label="Appearance">
        {OPTIONS.map(([value, text, Icon]) => (
          <button key={value} type="button" role="radio" aria-checked={preference === value} onClick={() => setPreference(value)}
            data-testid={`appearance-${value}`}
            className={`flex-1 inline-flex items-center justify-center gap-1 text-[11px] px-2 py-1 rounded-full font-medium transition-colors ${preference === value ? "bg-cyan-400 text-slate-900" : "text-slate-400 hover:text-white"}`}>
            <Icon className="w-3 h-3" aria-hidden="true" /> {text}
          </button>
        ))}
      </div>
    </div>
  );
};
